import 'css-chunksrc/client/scenes/taskCreation/taskCreationForm/participantsList/styles.scss';export default {
  "participantsList": "_participantsList_ojcft_1",
  "root": "_root_ojcft_8",
  "list": "_list_ojcft_12",
  "main": "_main_ojcft_19",
  "summary": "_summary_ojcft_26",
  "menu": "_menu_ojcft_35",
  "addParticipantIcon": "_addParticipantIcon_ojcft_39",
  "resourcesList": "_resourcesList_ojcft_45",
  "quickParticipantMenu": "_quickParticipantMenu_ojcft_52",
  "overlay": "_overlay_ojcft_60",
  "participants": "_participants_ojcft_1",
  "participant": "_participant_ojcft_1"
};